import styled from "styled-components"
import {WorkSansBold} from "@irati/ui/src/global/fonts"

const BASE_SIZE = 30

const ItemNumber = styled.div.attrs({
  size: BASE_SIZE
})`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  color: ${({theme}) => theme.colors.greys.white};
  background-color: ${({theme}) => theme.colors.greys.dark};
  ${WorkSansBold}
  ${({size}) => `
    height: ${size}px;
    width: ${size}px;
  `}
`

export default ItemNumber
